export default {
    title: 'Создать новую услугу',
    title_modify: 'Изменить услугу',
    subtitle: 'Введите данные об услуге',
    create_category: 'Пожалуйста, выберите категорию',
    category_types: 'Категории услуг:',
    progressbar: {
        service_data: 'Данные об услуге',
        category: 'Категория',
        photos: 'Фотографии',
        schedule: 'Расписание',
    },
    selected_category_number: 'Количество выбранных предложений: {number}',
    category_warning: 'Пожалуйста, добавьте хотя бы одну категорию',
    no_search_result: 'Мы не нашли услуги, соответствующие вашему запросу',
}
